import { UUID } from "../generic/uuid";
import { createVintageDtoFromAdminVintageModel, VintageModel } from "./vintage";
import {
  B2bMarketPriceModel,
  createB2BMarketPriceDtoFromAdminB2BMarketPriceModel,
} from "./b2bMarketPrice";
import { VintageProductDto } from "@vini-wine/core-dtos";

export interface VintageProductModel extends UUID {
  // transform
  milliliters: number;

  // available includes
  vintage?: VintageModel;
  b2bMarketPrice?: B2bMarketPriceModel | null;
}

export const createVintageProductDtoFromAdminVintageProductModel = (
  vintageProduct: VintageProductModel,
): VintageProductDto => {
  return {
    uuid: vintageProduct.uuid,
    milliliters: vintageProduct.milliliters,
    vintage: vintageProduct.vintage
      ? createVintageDtoFromAdminVintageModel(vintageProduct.vintage)
      : undefined,
    b2bMarketPrice: vintageProduct.b2bMarketPrice
      ? createB2BMarketPriceDtoFromAdminB2BMarketPriceModel(
          vintageProduct.b2bMarketPrice,
        )
      : undefined,
  };
};
